import { AbstractControl, ValidatorFn } from '@angular/forms';

export default class CustomValidation {


  static passwordMatch(enteredPassword: string, confirmedPassword: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const password = controls.get(enteredPassword);
      const confirmPassword = controls.get(confirmedPassword);
      if (!password?.value && confirmPassword?.value) {
        controls.get(confirmedPassword)?.setErrors({ matching: true });
        return { matching: true };
      }
      if (password?.value && !confirmPassword?.value) {
        controls.get(confirmedPassword)?.setErrors({ validation: true });
        return { validation: true };
      }
      if (confirmPassword?.errors && !confirmPassword.errors['matching']) {
        controls.get(confirmedPassword)?.setErrors(null);
        return null;
      }
      if (password?.value !== confirmPassword?.value && password?.value) {
        controls.get(confirmedPassword)?.setErrors({ matching: true });
        return { matching: true };
      }
      else {
        controls.get(confirmedPassword)?.setErrors(null);
        return null;
      }
    };
  }
  static validateEmail(email: string, userLevel: string): ValidatorFn {

    return (controls: AbstractControl) => {
      let emailData = controls.get(email);
      let userLevelData = controls.get(userLevel);
      let emailDomainList = "fluidra\.[a-z]{2,3}$|zodiac\.[a-z]{2,3}$";
      let emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
      let emailDomainExp = new RegExp(emailDomainList);
      let emailPatternExp = new RegExp(emailPattern);

      if (emailData?.value && (userLevelData?.value == 'support' || userLevelData?.value == 'support_user')) {
        let domain = String(emailData!.value).split('@')[1];
        if ((emailDomainExp.test(domain))) {
          controls.get(email)?.setErrors(null);
          return null;
        }
        else {
          controls.get(email)?.setErrors({ emailValidationError: true });
          return { emailValidationError: true };
        }
      }
      else {
        if ((emailPatternExp.test(emailData!.value))) {
          controls.get(email)?.setErrors(null);
          return null;
        }
        else {
          controls.get(email)?.setErrors({ emailPatternError: true });
          return { emailPatternError: true };
        }
      }
    };
  }
}

export function newPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): {[key:string]: boolean} | null => {
    let validationMap :any = {};
    if(control.value == "") {
      validationMap['length_zero'] = true;
      validationMap['no_upper_case'] = true;
      validationMap['no_lower_case'] = true;
      validationMap['min_length'] = true;
      validationMap['no_number'] = true;
      validationMap['no_special_chars'] = true;
    }
    
    if (control?.value !== "") {
      // validate if lenght is less than 8
    if(control.value.length < 8) {
      validationMap['min_length'] = true;
    }
      // validate if uppercase doesn't exists 
      let isUpperCaseNotExists  = control.value == control.value.toLowerCase()
      if(isUpperCaseNotExists) {
        validationMap['no_upper_case'] = true;
      }
      // validate if lowercase doesn't exists
      let isLowerCaseNotExists  = control.value == control.value.toUpperCase()
      if(isLowerCaseNotExists) {
        validationMap['no_lower_case'] = true;
      }
      // validate if number doesn't exists
      if(/[0-9]/.test(control?.value) == false) {
        validationMap['no_number'] = true;
      }
      // validate if special characters doesn't exists
      let validSpecialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if(validSpecialChars.test(control?.value) == false) {
        validationMap['no_special_chars'] = true;
      }
    }
    return validationMap;
  }
}

export function confirmPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): {[key:string]: boolean} | null => {
    let validationMap :any = {};

    if(control.get('confirmPassword')?.value === "") {
      validationMap['length_zero'] = true;
    }

    if(control.get('confirmPassword')?.value != "" && (control.get('newPassword')?.value != control.get('confirmPassword')?.value)) {
      validationMap['no_matching_pass']= true;
    }

    return validationMap;
  }
}